/**
 * Development-only logger. All calls are no-ops in production builds.
 * Replaces direct console.* usage to keep production bundles clean.
 */
const isDev = process.env.NODE_ENV === 'development';

const noop = () => {};

const logger = {
  log: isDev ? console.log.bind(console) : noop,
  warn: isDev ? console.warn.bind(console) : noop,
  error: isDev ? console.error.bind(console) : noop,
  info: isDev ? console.info.bind(console) : noop,
};

export default logger;
